module.exports = __webpack_public_path__ + "static/media/9.29e50a69.jpg";